import { IconPropsDeprecated } from '@umanforge/common';

export const MenuSvg = ( { className, size, onClick }: IconPropsDeprecated ) => {
  return (
    <svg
      className={ className }
      style={{ height: size, width: size }}
      onClick={ onClick }
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
      />
    </svg>
  );
};
